module.exports = __webpack_public_path__ + "img/item_image_1.aef2870f.jpg";